module.exports = __webpack_public_path__ + "resources/icon_blue_v.fb8ca469d5467ed2.png";